import { Popover } from '@ksyos/design-system';
import { formatString } from '@common/utils/formatString';
import { FormatCurrency } from '@frontend/components/elements/FormatCurrency';
import { getSelectedLanguage } from '@frontend/translate';

type AmountWithVatRate = { amount: number | null; vatRate?: string };

type AmountWithVatRateProps = {
    amountWithVatRate: AmountWithVatRate;
    display?: 'long' | 'short';
};

export function DisplayAmountWithVatRate({ display = 'long', amountWithVatRate }: AmountWithVatRateProps) {
    const amountAndVatInformation = getAmountAndVatRateInformation();

    const amount = amountAndVatInformation.amount && <FormatCurrency value={amountAndVatInformation.amount} />;
    const vatInformation = amountAndVatInformation.vatInformation ?? '';

    const completeAmountWithVatRate = (
        <>
            {amount}
            {vatInformation}
        </>
    );

    if (display === 'short' && vatInformation) {
        return <Popover content={completeAmountWithVatRate}>{amount}</Popover>;
    } else {
        return completeAmountWithVatRate;
    }

    function getAmountAndVatRateInformation() {
        if (amountWithVatRate.amount !== null && amountWithVatRate.vatRate) {
            const translate = getSelectedLanguage();

            const vatRate = parseFloat(amountWithVatRate.vatRate.replace(',', '.'));

            return {
                amount: amountWithVatRate.amount * (1 + vatRate),
                vatInformation: formatString(translate.costInfoAndConsentModal.costAndPaymentStep.information1c, [
                    `${vatRate * 100}`,
                ]),
            };
        } else {
            return { amount: amountWithVatRate.amount };
        }
    }
}
